import { Funder } from './funder';
import { ServiceType } from './service-type';
import { User } from './user';

export class TariffCode {
  code!: string;
  service_type_code!: string;
  description!: string;
  rate!: number;
  is_drug_tariff!: boolean;
  drug_tariff_type?: string;
  currency!: string;
  status!: string;
  date_deleted?: number;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  service_type?: ServiceType;

  constructor(data: any) {
    this.code = data.code;
    this.service_type_code = data.service_type_code;
    this.description = data.description;
    this.rate = data.rate;
    this.is_drug_tariff = data.is_drug_tariff ?? false;
    this.drug_tariff_type = data.drug_tariff_type;
    this.currency = data.currency;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.service_type) {
      this.service_type = new ServiceType(data.service_type);
    }
  }
}
